import axiosClient from '../util/request';
import { TypePublicPlace } from '../../interfaces/TypePublicPlace';
import { CountryBirth } from '../../interfaces/CountryBirth';
import { State } from '../../interfaces/State';
import { AddressData } from '../../interfaces/AddressData';

const addressRepo = {
  findAllCountries: () => axiosClient.get<CountryBirth[]>('/v1/countries'),
  findAllTypePublicPlace: () => axiosClient.get<TypePublicPlace[]>('/v1/type-street'),
  findAllStates: () => axiosClient.get<State[]>('/v1/states'),
  findAddress: (cep: string) => axiosClient.get<AddressData>(`https://viacep.com.br/ws/${cep}/json/`),
};

export default addressRepo;
